import React from "react";
import { TradeInAemLabel } from "../../../../utils/labels";
import TradeInAemVehicleResultBlock from "../TradeInAemVehicleResultBlock";
import * as Button from "../../../../../common-deprecated/styles/v2/toyota/components/Button";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import * as Text from "../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import * as Styles from "../styles/TradeInAem";
import { useTradeInCsl } from "../../../../csl/tradeInCslUtils";
import { getInternalLink } from "../../../../utils/navUtils";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../../../../redux/store";
import { TradeInAemNavStep } from "../../../../utils/constants";
import { useDispatch } from "../../../../../shared-logic/redux/store";

const ValuationFailedContainer = (): JSX.Element => {
    const csl = useTradeInCsl();
    const dispatch = useDispatch<TradeInAemDispatchType>();
    const currentStep = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);

    const editCarDetailsLink = getInternalLink(
        csl,
        currentStep,
        dispatch,
        commonSettings,
        TradeInAemNavStep.VehicleDetails,
    );

    const enableDetailsLink = csl.enabledNavSteps.includes(TradeInAemNavStep.VehicleDetails);

    return (
        <Styles.Main>
            <Styles.Container>
                <TradeInAemLabel label="tradeInAemValuationFailedContent" />
                <Styles.ButtonWrapper stretchMobile>
                    {enableDetailsLink && (
                        <Button.Link
                            large
                            mx={0}
                            mb={3}
                            as="a"
                            href={editCarDetailsLink.href}
                            onClick={editCarDetailsLink.onClick}
                            hasIcon
                        >
                            <IconWrapper>
                                <Icon variant="car" />
                            </IconWrapper>
                            <Text.Button>
                                <TradeInAemLabel label="tradeInAemValuationFailedEditCarDetails" />
                            </Text.Button>
                        </Button.Link>
                    )}
                    {/*<Button.Primary mx={0} mb={{ _: 2, md: 0 }} width={{ _: 1, md: "auto" }} as="a" href="#">*/}
                    {/*    <Text.Button>Add to deal</Text.Button>*/}
                    {/*</Button.Primary>*/}
                </Styles.ButtonWrapper>
                <TradeInAemVehicleResultBlock />
            </Styles.Container>
        </Styles.Main>
    );
};
export default ValuationFailedContainer;
